export const SET_SHOW_MODAL_RERENDER = "SET_SHOW_MODAL_RERENDER";
export const SET_SHOW_MODAL_NO_RERENDER = "SET_SHOW_MODAL_NO_RERENDER";
export const SET_SHOW_ACCEPT_PAP_MODAL = "SET_SHOW_ACCEPT_PAP_MODAL";
export const SET_SHOW_REJECT_PAP_MODAL = "SET_SHOW_REJECT_PAP_MODAL";
export const SET_SHOW_REJECT_DEVIS_MODAL = "SET_SHOW_REJECT_DEVIS";
export const SET_SHOW_ACCEPT_DEVIS_MODAL = "SET_SHOW_ACCEPT_DEVIS";
export const SET_SUCCESS_UPLOAD_MESS = "SET_SUCCESS_UPLOAD_MESS";
export const SET_ERROR_UPLOAD_MESS = "SET_ERROR_UPLOAD_MESS";
export const SET_SHOW_VIDEO_MODAL = "SET_SHOW_VIDEO_MODAL";
export const SET_SHOW_ACCOUNT_MODAL = "SET_SHOW_ACCOUNT_MODAL";
export const SET_SELECTED_VIDEO = "SET_SELECTED_VIDEO";
export const SET_SHOW_OFFER_MODAL = "SET_SHOW_OFFER_MODAL";

export const setShowModalRerender = (bool) => ({
	type : SET_SHOW_MODAL_RERENDER,
	bool
});
export const setShowModalNoRerender = (bool) => ({
	type : SET_SHOW_MODAL_NO_RERENDER,
	bool
});

export const setShowAcceptPapModal = (bool) => ({
	type : SET_SHOW_ACCEPT_PAP_MODAL,
	bool
});

export const setShowRejectPapModal = (bool) => ({
	type : SET_SHOW_REJECT_PAP_MODAL,
	bool
});

export const setShowAcceptDevisModal = (bool, id) => ({
	type : SET_SHOW_ACCEPT_DEVIS_MODAL,
	bool,
	id
});

export const setShowRejectDevisModal = (bool, id) => ({
	type : SET_SHOW_REJECT_DEVIS_MODAL,
	bool,
	id
});

export const setSuccessUploadMess = (msg) => ({
	type: SET_SUCCESS_UPLOAD_MESS,
	msg
});

export const setErrorUploadMess = (msg) => ({
	type: SET_ERROR_UPLOAD_MESS,
	msg
});

export const setShowAccountModal = (bool) => ({
	type: SET_SHOW_ACCOUNT_MODAL,
	bool
});

export const setShowVideoModal = (bool) => ({
	type: SET_SHOW_VIDEO_MODAL,
	bool
});

export const setSelectedVideo = (url) => ({
	type: SET_SELECTED_VIDEO,
	url
});

export const setShowOfferModal = (bool) => ({
	type: SET_SHOW_OFFER_MODAL,
	bool
});
